<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V9H16V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4C0 1.79086 1.79086 0 4 0H7V2Z" fill="white"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4502 2H8.99992V0H14.9999H15.9999V1V7H13.9999V3.28347L6.48873 10.5494C6.09178 10.9334 5.45871 10.9229 5.07472 10.526C4.69072 10.129 4.70123 9.49592 5.09818 9.11193L12.4502 2Z" fill="white"/>
</svg>

<style lang="stylus">
  svg
    vertical-align middle
</style>
